export const GOOGLE_PLAY_LINK = 'https://play.google.com/store/apps/details?id=ru.bos.opencity';

export const APP_STORE_LINK =
  'https://apps.apple.com/ru/app/%D0%BE%D1%82%D0%BA%D1%80%D1%8B%D1%82%D1%8B%D0%B9-%D0%B3%D0%BE%D1%80%D0%BE%D0%B4-%D0%B7%D0%B0%D1%8F%D0%B2%D0%BA%D0%B8-%D0%B6%D0%BA%D1%85/id6444889044';

export const APP_GALLERY_LINK =
  'https://appgallery.cloud.huawei.com/ag/n/app/C109920673?locale=ru_RU&source=appshare&subsource=C109920673&shareTo=org.telegram.messenger&shareFrom=appmarket&shareIds=c376ffdeaf8843e5b1b4d7c3585ff2cd_org.telegram.messenger&callType=SHARE';
